import type { CustomFilterConfig } from 'hooks/useDirectoryData/types';

import { localize } from '../helpers/localize';
import { toggleValue } from '../helpers/toggleValue';

export interface CustomCheckboxFilterProps {
  filter: CustomFilterConfig;
  selected: string[];
  locale: string;
  onChange: (selected: string[]) => void;
}

function CustomCheckboxFilter({ filter, selected, locale, onChange }: CustomCheckboxFilterProps) {
  return (
    <div className="checkboxOptions">
      <span className="title">{localize(filter.label, locale)}</span>

      {filter.options.map((option) => {
        return (
          <div key={option.value} className="checkboxDiv">
            <label className="checkbox-label">
              <span className="labelName">{localize(option.label, locale)}</span>
              <input
                type="checkbox"
                checked={selected.includes(option.value)}
                onChange={() => {
                  onChange(toggleValue(selected, option.value, filter.multiple));
                }}
              />
              <span className="checkmark" />
            </label>
          </div>
        );
      })}
    </div>
  );
}

export default CustomCheckboxFilter;
